/**
 * Audit log types for COMP-006 — append-only, hash-chained audit trail.
 * 50 event types across 6 source components + scheduled tasks + 2 future.
 */
export const AUDIT_EVENT_TYPES = [
    // COMP-001: Authentication (3)
    "AUTH_TOKEN_VALIDATED",
    "AUTH_TOKEN_REJECTED",
    "USER_LOGGED_OUT",
    // COMP-002: Customer Config (7)
    "CUSTOMER_CONFIG_CHANGED",
    "CUSTOMER_ACCESS_TYPE_CHANGED",
    "CUSTOMER_ONBOARDED",
    "CACHE_REFRESH_MANUAL",
    "CACHE_REFRESH_COMPLETED",
    "CACHE_REFRESH_FAILED",
    "WEBHOOK_AUTH_FAILED",
    // COMP-003: Technician Access (7)
    "ACCESS_CHECK_EVALUATED",
    "TECHNICIAN_ATTRIBUTES_UPDATED",
    "TECHNICIAN_ACCESS_REVOKED",
    "TECHNICIAN_TIER_CHANGED",
    "TECHNICIAN_CLEARANCE_CHANGED",
    "TECHNICIAN_LOCATION_CHANGED",
    "TECHNICIAN_OFFBOARDED",
    // COMP-004: GDAP Relationships (12)
    "GDAP_RELATIONSHIP_CREATED",
    "GDAP_RELATIONSHIP_APPROVED",
    "GDAP_RELATIONSHIP_EXPIRED",
    "GDAP_RELATIONSHIP_TERMINATED",
    "GDAP_ASSIGNMENTS_CREATED",
    "GDAP_ACCESS_ASSIGNMENT_DELETED",
    "GDAP_RECONCILIATION_COMPLETE",
    "GDAP_EXPIRY_WARNING",
    "GDAP_CREATION_FAILED",
    "EXCEPTION_GROUP_MEMBER_ADDED",
    "EXCEPTION_GROUP_MEMBER_REMOVED",
    "EXCEPTION_GROUP_CREATED",
    "EXCEPTION_GROUP_DELETED",
    "SETTINGS_CHANGED",
    // COMP-005: PIM Sessions (10)
    "PIM_SESSION_ACTIVATED",
    "PIM_SESSION_EXTENDED",
    "PIM_SESSION_EXPIRED",
    "PIM_SESSION_DEACTIVATED",
    "PIM_SESSION_REVOKED",
    "PIM_ACTIVATION_FAILED",
    "PIM_REVOCATION_SLA_BREACH",
    "PIM_ORPHANED_ASSIGNMENT",
    "CUSTOMER_ACCESS_VIEWED",
    "CUSTOMER_ACCESS_CONNECTED",
    // COMP-005: PIM Approval Workflow (5)
    "PIM_APPROVAL_REQUESTED",
    "PIM_APPROVAL_GRANTED",
    "PIM_APPROVAL_DENIED",
    "PIM_ELIGIBILITY_ASSIGNED",
    "PIM_ELIGIBILITY_REMOVED",
    // COMP-005: Approval Policies (1)
    "APPROVAL_POLICIES_CHANGED",
    // COMP-006: Audit Trail (1 self-audit)
    "RETENTION_POLICY_CHANGED",
    // COMP-007: Portal Settings (2)
    "PORTAL_SETTINGS_CHANGED",
    "ENTRA_GROUP_CREATED",
    // COMP-009: Notifications (2)
    "NOTIFICATION_SENT",
    "NOTIFICATION_DELIVERY_FAILED",
    // COMP-009: HaloPSA Integration (1)
    "HALOPSA_API_CALL",
    // Scheduled Tasks (4)
    "SCHEDULED_TASK_COMPLETED",
    "SCHEDULED_TASK_FAILED",
    "SCHEDULED_TASK_TOGGLED",
    "SCHEDULED_TASK_MANUAL_RUN",
    // Future (2)
    "ACCESS_REVIEW_COMPLETED",
    "ACCESS_REVIEW_DUE",
];
export const AUDIT_SEVERITY_LEVELS = ["INFO", "WARNING", "CRITICAL"];
//# sourceMappingURL=audit.js.map